import { useSettings, useStore } from '../context/store';

export default function useGetListings() {
    const {
        state,
        dispatch,
    } = useStore();

    const settings = useSettings();

    const getRequestUrl = function( perPage, page ) {
        let url = `${WP.siteUrl}/wp-json/ygl/rentals-search?`;

        if ( settings.perPage ) {
            url += `page_count=${settings.perPage}&`;
        }

        if ( page > 1 ) {
            url += `page_index=${page}&`;
        }

        if ( null !== state.sortBy && null !== state.sortBy.sort_name ) {
            url += `sort_dir=${state.sortBy.sort_dir}&sort_name=${state.sortBy.sort_name}&`;
        }

        if ( Object.keys( state.filters ).length ) {
            for ( const filter in state.filters ) {
                const value = state.filters[ filter ];

                if ( null !== value && '' !== value )
                url += `${filter}=${value}&`;
            }
        }

        return url;
    }

    const getListings = async function( perPage = 18, page = 1 ) {

        const url = getRequestUrl( perPage, page )

        dispatch({ type: 'setLoading', payload: true });

        const response = await fetch( url );
        const data = await response.json();

        data.payload.page = page;

        dispatch({ type: 'setSearchResults', payload: data.payload });
        dispatch({ type: 'setLoading', payload: false });
    }

    return {
        getListings
    }
}